import { Debug } from '@/components/Models/debug'
import type { useRewardFlowStateMachine } from '@/features/pages/rewards/detail/useRewardFlowStateMachine'

type RewardFlowState = ReturnType<typeof useRewardFlowStateMachine>

type Props = {
  flow: RewardFlowState
  isAuthenticated: boolean
  enabled: boolean
}

const resolveStateName = (state: RewardFlowState['state']): string => {
  const v = state.value
  return typeof v === 'string' ? v : JSON.stringify(v)
}

export const RewardDetailStateMachineDebug = ({ flow, isAuthenticated, enabled }: Props) => {
  const { state, reward, userRewardStatus, transaction, errorMessage, completedVia, isUserStatusLoading } = flow
  const ctx = state.context

  return (
    <Debug
      title="reward-flow"
      text={[
        `state := ${resolveStateName(state)}`,
        `rewardId := ${ctx.rewardId}`,
        `isAuthenticated(prop) := ${isAuthenticated}`,
        `isAuthenticated(ctx) := ${ctx.isAuthenticated}`,
        `enabled := ${enabled}`,
        `userRewardStatus.status := ${userRewardStatus?.status ?? 'null'}`,
        `ctx.userRewardStatus.status := ${ctx.userRewardStatus?.status ?? 'null'}`,
        `reward.name := ${reward?.name ?? 'null'}`,
        `transaction.prize.type := ${transaction?.prize?.type ?? 'null'}`,
        `transaction.transactionId := ${transaction?.transactionId ?? 'null'}`,
        `completedVia := ${completedVia ?? 'null'}`,
        `errorMessage := ${errorMessage ?? 'null'}`,
        `isUserStatusLoading := ${isUserStatusLoading}`,
      ]}
    />
  )
}
